/**
 * Auto-refresh hook for version checking
 * Automatically reloads the page when a new version is detected
 */

const CHECK_INTERVAL = 30000; // Check every 30 seconds for faster updates
const VERSION_KEY = 'g2gente_app_version';
const LAST_UPDATE_KEY = 'g2gente_last_update';

let currentVersion = null;
let isChecking = false;

// Função para limpar todos os caches do navegador
async function clearAllCaches() {
  try {
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
      console.log('[AutoRefresh] Todos os caches limpos');
    }
  } catch (error) {
    console.error('[AutoRefresh] Erro ao limpar caches:', error);
  }
}

// Função para forçar atualização completa
async function forceFullUpdate() {
  console.log('[AutoRefresh] Forçando atualização completa...');
  
  // Limpar caches
  await clearAllCaches();
  
  // Remover service worker antigo
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(r => r.unregister()));
    console.log('[AutoRefresh] Service Workers removidos');
  }
  
  // Marcar hora da atualização
  localStorage.setItem(LAST_UPDATE_KEY, Date.now().toString());
  
  // Recarregar a página
  window.location.reload(true);
}

export async function checkForUpdates() {
  if (isChecking) return;
  isChecking = true;
  
  try {
    const response = await fetch('/api/version', {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });
    
    if (!response.ok) {
      isChecking = false;
      return;
    }
    
    const data = await response.json();
    const serverVersion = data.version;
    
    // First load - store version
    if (!currentVersion) {
      currentVersion = localStorage.getItem(VERSION_KEY);
    }
    
    // If we have a stored version and it's different, force full update
    if (currentVersion && currentVersion !== serverVersion) {
      console.log(`[AutoRefresh] Nova versão detectada: ${currentVersion} -> ${serverVersion}`);
      localStorage.setItem(VERSION_KEY, serverVersion);
      
      // Forçar atualização completa com limpeza de cache
      await forceFullUpdate();
      return;
    }
    
    // Store current version
    if (!currentVersion) {
      currentVersion = serverVersion;
      localStorage.setItem(VERSION_KEY, serverVersion);
    }
    
  } catch (error) {
    console.log('[AutoRefresh] Version check failed:', error.message);
  } finally {
    isChecking = false;
  }
}

export function startVersionCheck() {
  // Check immediately on start
  checkForUpdates();
  
  // Then check periodically
  setInterval(checkForUpdates, CHECK_INTERVAL);
  
  // Also check when tab becomes visible (user returns to the app)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkForUpdates();
    }
  });
  
  // Check on window focus
  window.addEventListener('focus', () => {
    checkForUpdates();
  });
}

export function clearVersionCache() {
  localStorage.removeItem(VERSION_KEY);
  currentVersion = null;
}
